import React, { createContext, useState } from "react";

import { Icon, ICONS } from "../../Icons";
import { StyledMobileNotification } from "./styled";

export const MobileNotificationContext = createContext({});

export const MobileNotification = ({ children }) => {
  const [isDisplayNotification, setDisplayNotification] = useState(true);

  return (
    <MobileNotificationContext.Provider value={isDisplayNotification}>
      <StyledMobileNotification>
        {/* previous code - <div className="show-on-mobile"> */}
        <div className="display-none">
          {isDisplayNotification && (
            <div className={"mobileNotification"}>
              <p className={"paper"}>Use the desktop to access all the services of Quick Apply</p>
              <div className={"closeIconWrapper"}>
                <Icon
                  name={ICONS.closeWhite}
                  className={"closeIcon"}
                  onClick={() => setDisplayNotification(false)}
                />
              </div>
            </div>
          )}
        </div>
      </StyledMobileNotification>
      {children}
    </MobileNotificationContext.Provider>
  );
};
